import { gql } from '@apollo/client'

export const fetchAppContextQuery = gql`
  query FetchAppContext {
    allFirms {
      firmName
    }
  }
`
